/**
 * SQL Column Constants
 * Mirrors api/sql/constants.js for consistent field naming between frontend and backend
 * Each constant is commented with the table(s) it is used in
 */

// Grades table
export const COL_GRADE_ID = 'grade_id'; // Grades, Products_Grades
export const COL_GRADE_NAME = 'grade_name'; // Grades, Products_Grades
export const COL_USER_ID = 'user_id'; // Grades, Products, Manufacturers, Facilities, therapeutic_areas
export const COL_CREATED_DATE = 'created_date'; // Grades, Products, Manufacturers, Facilities, therapeutic_areas
export const COL_MODIFIED_DATE = 'modified_date'; // Grades, Products, Manufacturers, Facilities, therapeutic_areas

// Products table
export const COL_PRODUCT_ID = 'product_id'; // Products, Products_Grades, Products_Manufacturers, Products_Facilities, Products_TherapeuticAreas
export const COL_PRODUCT_NAME = 'product_name'; // Products
export const COL_CAS_NUMBER = 'cas_number'; // Products
export const COL_NOTE = 'note'; // Products
export const COL_URI = 'uri'; // Products
export const COL_IMG = 'img'; // Products
export const COL_INCHI = 'inchi'; // Products
export const COL_INCHI_KEY = 'inchi_key'; // Products
export const COL_SMILE = 'smile'; // Products
export const COL_CANONICAL_SMILE = 'canonical_smile'; // Products
export const COL_MOLECULAR_FORMULA = 'molecular_formula'; // Products
export const COL_MOLECULAR_MASS = 'molecular_mass'; // Products
export const COL_PRODUCT_SYNONYM = 'product_synonym'; // Products
export const COL_REPLACED_RN = 'replaced_rn'; // Products
export const COL_MANUFACTURING_STATUS = 'manufacturing_status'; // Products

// Manufacturers table
export const COL_MANUFACTURER_ID = 'manufacturer_id'; // Manufacturers, Facilities, Products_Manufacturers, Manufacturer_Facilities
export const COL_MANUFACTURER_NAME = 'manufacturer_name'; // Manufacturers
export const COL_PREFERRED_PRODUCT_NAME = 'preferred_product_name'; // Products table

// Facilities table
export const COL_FACILITY_ID = 'facility_id'; // Facilities, Products_Facilities, Manufacturer_Facilities
export const COL_FACILITY_NAME = 'facility_name'; // Facilities
export const COL_IS_PRIMARY = 'is_primary';
export const COL_FEI_NUMBER = 'fei_number';
export const COL_DUNS_NUMBER = 'duns_number';
export const COL_ADDRESS_LINE1 = 'address_line1';
export const COL_ADDRESS_LINE2 = 'address_line2';
export const COL_CITY = 'city';
export const COL_STATE_PROVINCE = 'state_province';
export const COL_POSTAL_CODE = 'postal_code';
export const COL_COUNTRY_CODE = 'country_code';
export const COL_QTA_STATUS = 'qta_status';
export const COL_QTA_EFFECTIVE_DATE = 'qta_effective_date';
export const COL_QTA_EXPIRATION_DATE = 'qta_expiration_date';
export const COL_COMMENTS = 'comments';
export const COL_AUDIT_DATE = 'audit_date';
export const COL_AUDIT_TYPE = 'audit_type';
export const COL_LATITUDE = 'latitude';
export const COL_LONGITUDE = 'longitude';
export const COL_FACILITY_STATUS = 'facility_status';

// Therapeutic Areas table
export const COL_THERAPEUTIC_AREA_ID = 'therapeutic_area_id'; // therapeutic_areas, Products_TherapeuticAreas
export const COL_THERAPEUTIC_AREA_NAME = 'therapeutic_area_name'; // therapeutic_areas

// Audit_Log table
export const COL_AUDIT_ID = 'audit_id'; // Audit_Log
export const COL_TABLE_NAME = 'table_name'; // Audit_Log
export const COL_RECORD_ID = 'record_id'; // Audit_Log
export const COL_OPERATION_TYPE = 'operation_type'; // Audit_Log
export const COL_FIELD_NAME = 'field_name'; // Audit_Log
export const COL_OLD_VALUE = 'old_value'; // Audit_Log
export const COL_NEW_VALUE = 'new_value'; // Audit_Log
export const COL_CHANGED_BY = 'changed_by'; // Audit_Log
export const COL_CHANGED_DATE = 'changed_date'; // Audit_Log
export const COL_CHANGE_REASON = 'change_reason'; // Audit_Log
